<template>
  <a-menu
      :mode="mode"
      :theme="theme"
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
      @openChange="onOpenChange"
  >
    <template v-for="m in menu" :key="m.path">
      <RenderSubMenu :menu="m" v-if="!m.hidden"/>
    </template>
  </a-menu>
</template>

<script>

import RenderSubMenu from "./RenderSubMenu";
import {computed, onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";

export default {
  name: "Menu",
  components: {
    RenderSubMenu,
  },
  props: {
    menu: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const router = useRouter();
    // ques:todo:router.currentRoute就保留了响应式router.currentRoute.value响应式就没了?难道.value等于取值了?,如果是响应没了,为什么点击菜单就显示正常,而使用代码跳转路由就不正常呢,难道是vue-router4的bug?
    const route = router.currentRoute;
    const openKeys = ref([]);
    const selectedKeys = ref([]);
    const cachedOpenKeys = ref([]);
    const rootSubmenuKeys = computed(() => {
      const keys = []
      props.menu.forEach((item) => {
        console.log("---> set menu : %o", item);
        keys.push(item.path);
      })
      return keys
    })
    onMounted(() => {
      updateMenu()
    })

    watch(
        () => props.collapsed,
        (val) => {
          if (val) {
            cachedOpenKeys.value = openKeys.value.concat()
          } else {
            openKeys.value = cachedOpenKeys.value
          }
        }
    )

    // 主要作用:使用router.push跳转页面时更左侧新菜单选中项
    watch(
        () => route.value,
        () => {
          updateMenu()
        }
    )

    // select menu item
    const onOpenChange = (openKeysParams) => {
      // 在水平模式下时执行，并且不再执行后续
      if (props.mode === 'horizontal') {
        openKeys.value = openKeysParams
        return
      }
      // 非水平模式时
      const latestOpenKey = openKeysParams.find(
          (key) => /*去掉这个!则可以全部打开菜单(目前只能打开一个菜单)*/ !openKeys.value.includes(key)
      )
      if (!rootSubmenuKeys.value.includes(latestOpenKey)) {
        openKeys.value = openKeysParams
      } else {
        openKeys.value = latestOpenKey ? [latestOpenKey] : []
      }
    }

    const updateMenu = () => {
      const routes = route.value.matched.concat()
      const {hidden} = route.value.meta
      if (routes.length >= 3 && hidden) {
        routes.pop()
        selectedKeys.value = [routes[routes.length - 1].path]
      } else {
        selectedKeys.value = [routes.pop().path]
      }
      const openKeysArr = []
      if (props.mode === 'inline') {
        routes.forEach((item) => {
          openKeysArr.push(item.path)
        })
      }
      props.collapsed ? (cachedOpenKeys.value = openKeysArr) : (openKeys.value = openKeysArr)
    }

    return {
      openKeys,
      selectedKeys,
      onOpenChange,
    }
  }
}
</script>

<style scoped>

</style>